import { ProductStatusEnum } from "helpers/types";
import { CustomButton } from "Components/CustomButton";
import LockRed from "assets/svg/LockRed.svg";
import Lock from "assets/svg/Lock.svg";
import styles from "./index.module.css";

type Props = {
  status: ProductStatusEnum;
  isAdRestricted: boolean;
  onConfirm: () => void;
  onDecline: () => void;
  onBlock: () => void;
  onUnBlock: () => void;
  isBlockButtonLoading: boolean;
  isAllButtonLoading: boolean;
  hasDraft: boolean;
};
export const ActionsComponent = ({
  isAdRestricted,
  onConfirm,
  onDecline,
  status,
  onBlock,
  onUnBlock,
  isBlockButtonLoading,
  isAllButtonLoading,
  hasDraft,
}: Props) => {
  console.log(status, hasDraft);
  return (
    <>
      {status === ProductStatusEnum.PENDING ? (
        <>
          <CustomButton
            sizeButton="medium"
            typeButton="primary"
            onClick={onConfirm}
            disabled={isAdRestricted}
            loading={isAllButtonLoading}
          >
            Confirm
          </CustomButton>
          <CustomButton
            sizeButton="medium"
            typeButton="critical"
            onClick={onDecline}
            disabled={isAdRestricted}
            loading={isAllButtonLoading}
          >
            Decline
          </CustomButton>
        </>
      ) : null}
      {isAdRestricted ? (
        <CustomButton
          sizeButton="medium"
          typeButton="tertiary"
          onClick={onUnBlock}
          loading={isBlockButtonLoading || isAllButtonLoading}
        >
          <div className={styles.contentBtnWrapper}>
            <img src={Lock} alt="lock" />
            <div>Unblock</div>
          </div>
        </CustomButton>
      ) : (
        <CustomButton
          sizeButton="medium"
          typeButton="critical"
          onClick={onBlock}
          loading={isBlockButtonLoading || isAllButtonLoading}
        >
          <div className={styles.contentBtnWrapper}>
            <img src={LockRed} alt="lock" />
            <div>Block</div>
          </div>
        </CustomButton>
      )}
    </>
  );
};
